module.exports = __webpack_public_path__ + "img/logo.4249fe36.png";